<div class="modal-body text-center" [class.crop-image-modal-body]="imgUrl">
  <i class="icon-close app-close font-xl align-self-end p-4 pointer"
     (click)="modal.dismiss('Close click')">
  </i>
  <ui-choose-motive-cropper
    [imgUrl]="imgUrl"
    [file]="file"
    [maxImageSize]="maxImageSize"
    [enableResize]="enableResize"
    [selectedAspectRatio]="selectedAspectRatio"
    [aspectRatios]="aspectRatios"
    [fitIntoAspectRatio]="fitIntoAspectRatio"
    [keepBgTransparent]="keepBgTransparent"
    [imagesForChooseSrc]="imagesForChooseSrc"
    (onResultUrlChanged)="onResultUrlChanged($event)"
    (onImgUrlChanged)="imgUrl = $event"
    (onRatioChanged)="selectedAspectRatio = $event"
    (onFileChosen)="file = $event"
  ></ui-choose-motive-cropper>
</div>
<div class="modal-footer justify-content-center"
     *ngIf="imgUrl">
  <button class="btn btn-outline-primary"
          type="button"
          (click)="file = null; imgUrl = null;"
          [translate]="'cakeBuilder.cakeMotiveSection.uploadImage.uploadNew'">
  </button>
  <button class="btn btn-pink"
          type="button"
          (click)="uploadImage()"
          [translate]="'cakeBuilder.cakeMotiveSection.uploadImage.confirm'">
    Confirm
  </button>
</div>
